import { quizColumns } from "./-components/quiz-columns"
import { CreateQuizDialog } from "./-components/create-quiz-dialog"
import { useState } from "react"
import { createFileRoute } from "@tanstack/react-router"
import { useQuery } from "convex/react"
import { z } from "zod"
import { Plus } from "lucide-react"
import { api } from "@convex/_generated/api"
import { Button } from "@/components/ui/button"
import { DataTable } from "@/components/ui/data-table"
import { Skeleton } from "@/components/ui/skeleton"

const quizzesSearchSchema = z.object({
  name: z.string().optional().catch(undefined),
})

export const Route = createFileRoute("/(admin)/admin/quizzes/")({
  component: RouteComponent,
  validateSearch: quizzesSearchSchema,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { name } = Route.useSearch()
  const [createDialogOpen, setCreateDialogOpen] = useState(false)
  const quizzes = useQuery(api.quizzes.handlers.list)

  const handleNameFilterChange = (value: string) => {
    navigate({
      search: (prev) => ({
        ...prev,
        name: value || undefined,
      }),
    }).catch((error: unknown) => {
      console.error("Navigation error:", error)
    })
  }

  if (!quizzes) {
    return (
      <div className="flex flex-1 flex-col gap-4 p-4">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold">Quizzes</h1>
            <p className="text-sm text-muted-foreground">
              Manage quizzes and their questions
            </p>
          </div>
          <Button
            onClick={() => {
              setCreateDialogOpen(true)
            }}
          >
            <Plus className="h-4 w-4 mr-2" />
            Create Quiz
          </Button>
        </div>
        <div className="space-y-4">
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-[400px] w-full" />
        </div>
        <CreateQuizDialog
          open={createDialogOpen}
          onOpenChange={setCreateDialogOpen}
        />
      </div>
    )
  }

  return (
    <div className="flex flex-1 flex-col gap-4 p-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold">Quizzes</h1>
          <p className="text-sm text-muted-foreground">
            Manage quizzes and their questions
          </p>
        </div>
        <Button
          onClick={() => {
            setCreateDialogOpen(true)
          }}
        >
          <Plus className="h-4 w-4 mr-2" />
          Create Quiz
        </Button>
      </div>

      <DataTable
        columns={quizColumns}
        data={quizzes}
        filterColumn="name"
        filterPlaceholder="Filter by name..."
        filterValue={name}
        onFilterChange={handleNameFilterChange}
        onRowClick={(quiz) => {
          navigate({
            to: "/admin/quizzes/$quizId",
            params: { quizId: quiz._id },
          }).catch((error: unknown) => {
            console.error("Navigation error:", error)
          })
        }}
      />

      <CreateQuizDialog
        open={createDialogOpen}
        onOpenChange={setCreateDialogOpen}
      />
    </div>
  )
}
